import AIResponse from "./AIResponse";
import UserRequest from "./UserRequest";

type ConversationMarkerProps = {
    at: Date;
    summary: string;
};

/**
 * A mark in the assistant's thread (step-based contract): the conversation was compacted here.
 * Display only: for the assistant, what came before is replaced by `summary`.
 */
export default class ConversationMarker {
    at: Date;

    summary: string;

    constructor(props: ConversationMarkerProps) {
        this.at = props.at;
        this.summary = props.summary;
    }
}

/** One item of the assistant's thread. */
export type ThreadItem = UserRequest | AIResponse | ConversationMarker;
